module.exports = __webpack_public_path__ + "li.svg?ca65e1ea4a1fbe7863b70ab6a24d8ac8";